/**
 * Configured API instance using swagger-typescript-api generated client
 * This connects the generated Api class to our authenticated axios client
 */

import { Api } from './generated-sta/Api';
import { apiConfig } from '@/config';
import { attachAuthInterceptors, getOidcTokenFromStorage } from './authInterceptors';

/**
 * Token getter – defaults to reading the OIDC localStorage store so API calls
 * that fire before AppShell mounts still carry a Bearer token. AppShell swaps
 * in the renew-or-fail getter (AuthProvider.getAccessToken) via setApiTokenGetter.
 */
let getAccessToken: () => Promise<string | null> = async () => getOidcTokenFromStorage();

/**
 * Set the token getter function (called by AppShell)
 */
export const setApiTokenGetter = (getter: () => Promise<string | null>) => {
  getAccessToken = getter;
};

/**
 * Serialize query params so arrays use repeated keys (e.g. operationIds=a&operationIds=b)
 * which is what ASP.NET Core model binding expects.
 * Axios default uses bracket notation (operationIds[0]=a) which the backend ignores.
 */
const serializeParams = (params: Record<string, unknown>): string => {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) continue;
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== null && item !== undefined) {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`);
        }
      }
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    }
  }
  return parts.join('&');
};

/**
 * Configured API instance with authentication
 */
export const api = new Api({
  baseURL: apiConfig.baseUrl,
  timeout: apiConfig.timeout,
  secure: true,
  paramsSerializer: serializeParams,
});

// Shared request/response interceptors (auth + tenant + ND 401 refresh +
// session-expired routing). Consolidated in authInterceptors.ts so this
// swagger-typescript-api `Api` instance and the orval mutator (client.ts) stay
// in sync.
attachAuthInterceptors(api.instance, { getToken: () => getAccessToken() });

// Export the instance for direct use
export default api;
